/**
 * PatchFormGroupValues directive updates the form state
 * as the user type.
 *
 * form should set to its initial state after the success action.
 */
import { Directive, Input } from '@angular/core'

@Directive({
  selector: '[patchFormGroupValues]',
})
export class PatchFormGroupValuesDirective {
  @Input() formGroup: any
  @Input()
  set patchFormGroupValues(val: any) {
    if (!val) return
    this.formGroup.patchValue(val, { emitEvent: false })
  }
}
